"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

require("./ResponsiveWrapper.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The responsive wrapper is used to display content that needs to be swapped in/out based on screen width.
 * It works as a wrapper for react-responsive (https://github.com/contra/react-responsive)
 */
var ResponsiveWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ResponsiveWrapper, _React$PureComponent);

  var _super = _createSuper(ResponsiveWrapper);

  function ResponsiveWrapper(props) {
    var _this;

    _classCallCheck(this, ResponsiveWrapper);

    _this = _super.call(this, props);
    var children = props.children;

    if (children.length <= 0) {
      console.warn('At least one child should be provided to the ResponsiveWrapper object'); // eslint-disable-line no-console
    }

    return _this;
  }

  _createClass(ResponsiveWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          breakpoints = _this$props.theme.breakpoints,
          children = _this$props.children;
      var childrenArray = Array.isArray(children) ? children : [children];
      return /*#__PURE__*/_react.default.createElement("div", null, breakpoints.map(function (breakpoint, index) {
        // The following allows you to specify just one component (the smallest) and it will be used at greater widths if others are not specified
        var child = childrenArray[index];

        if (!child) {
          var i = index;

          while (i >= 0 && !child) {
            child = childrenArray[i];
            i--;
          }
        }

        return /*#__PURE__*/_react.default.createElement(_reactResponsive.default, {
          key: breakpoint,
          minWidth: breakpoints[index - 1] || 0,
          maxWidth: breakpoints[index + 1] ? breakpoint : undefined
        }, child);
      }));
    }
  }]);

  return ResponsiveWrapper;
}(_react.default.PureComponent);

_defineProperty(ResponsiveWrapper, "propTypes", {
  /**
   * Child nodes are mapped to corresponding breakpoints.
   * If the same component can be used for multiple breakpoints, you can either:<br /><br />
   * 1) provide the same component for multiple mappings<br />
   * 2) provide the component for the smallest size that uses it - larger sizes that are not explicitly provided components will default to a smaller version<br /><br />
   * If One component is used for all breakpoints, do not bother wrapping it in this component
   */
  children: _propTypes2.default.children.isRequired,

  /**
   * The standard theme object, which should come with the current breakpoints
   */
  theme: _propTypes.default.shape({
    breakpoints: _propTypes.default.array
  }).isRequired
});

var _default = (0, _styledComponents.withTheme)(ResponsiveWrapper);

exports.default = _default;